import React from 'react';

import { AvGroup } from 'availity-mobx-reactstrap-validation';
import MoneyInput from './MoneyInput';

export default props => (
  <AvGroup>
    {/*<MoneySign />*/}
    <MoneyInput {...props} />
  </AvGroup>
);
